import type { GraphqlConnectionNode, GraphqlPageInfo } from '@ctw/shared/api/fqs/client';
import type { ServiceRequest } from 'fhir/r4';
import { gql } from 'graphql-request';
import { fragmentServiceRequest } from './fragments';

export interface ServiceRequestConnection {
  pageInfo: GraphqlPageInfo;
  edges: Array<GraphqlConnectionNode<ServiceRequest>>;
}

export interface ServiceRequestGraphqlResponse {
  ServiceRequestConnection: ServiceRequestConnection;
}

export const ServiceRequestQuery = gql`
  ${fragmentServiceRequest}

  query ServiceRequests(
    $upid: ID!
    $cursor: String!
    $sort: ServiceRequestSortParams!
    $filter: ServiceRequestFilterParams! = {}
    $first: Int!
  ) {
    ServiceRequestConnection(
      upid: $upid
      after: $cursor
      sort: $sort
      filter: $filter
      first: $first
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...ServiceRequest
        }
      }
    }
  }
`;
